// Shared API helpers for the Incomm VOID Report tile.
//
// The upstream ShipStore endpoint cannot be called from the browser (it sends
// no CORS headers and answers OPTIONS with 405), so everything goes through
// our own /api/incomm-void-report, which also does the row enrichment.

const API_URL = process.env.REACT_APP_API_URL ||
  (window.location.hostname === 'localhost' ? 'http://localhost:5000/api' : '/api');

export const VOID_REPORT_API_BASE = `${API_URL}/incomm-void-report`;

const authHeaders = (extra = {}) => {
  const token = localStorage.getItem('token');
  return {
    Authorization: token ? `Bearer ${token}` : '',
    ...extra,
  };
};

const handle = async (res) => {
  if (!res.ok) {
    let detail = '';
    let body = null;
    try { body = await res.json(); detail = body.message || body.details || ''; } catch (_) {}
    const err = new Error(detail || `Request failed: ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return res.json();
};

/** Pull the report for an inclusive YYYY-MM-DD range. */
export const fetchVoidReport = ({ startDate, endDate, signal }) =>
  fetch(
    `${VOID_REPORT_API_BASE}?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
    { headers: authHeaders(), signal }
  ).then(handle);
